import React, { useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { PagesProvider } from '@/core/contexts/PagesContext';
import { ScheduleContent } from './pages/create/ScheduleContent';
import { ListScheduledContent } from './pages/list/ListScheduledContent';
import { useAuth } from '@/core/hooks/useAuth';
import { Loader } from '@/core/components/Loader/Loader';
import Wrapper from '@/core/components/Wrapper/Wrapper';
import { initializeBlipDS } from '@/core/utils/webComponent';
import { Paths } from '@/routes/paths/Paths';
import { useAppLanguage } from '@/core/hooks/useAppLanguage';

export const SchedulerApp: React.FC = () => {
  useAppLanguage();

  const { hasInitialData } = useAuth();

  useEffect(() => {
    initializeBlipDS();
  }, []);

  if (!hasInitialData) {
    return <Loader />;
  }

  return (
    <Wrapper>
      <BrowserRouter>
        <PagesProvider channel="facebook_instagram">
          <Routes>
            {/* Suporte a caminho raiz no Web Component e caminhos absolutos do Paths */}
            <Route path="/" element={<ScheduleContent />} />
            <Route path={Paths.createScheduledContent} element={<ScheduleContent />} />
            <Route path={Paths.listScheduledContent} element={<ListScheduledContent />} />
            <Route path="*" element={<Navigate to={Paths.createScheduledContent} replace />} />
          </Routes>
        </PagesProvider>
      </BrowserRouter>
    </Wrapper>
  );
};
